import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, TokensService } from '../services';
import { StorageService } from '../services';

import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'clientswitch',
  providers: [TokensService, StorageService],
  templateUrl: './clientswitch.component.html',
  styleUrls: ['./clientswitch.component.scss']
})
export class ClientswitchComponent implements OnInit {

  clients: any[];
  client: string;
  storageName: string;
  storages: any[];
  user: string;

  constructor(
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private authenticationService: AuthenticationService,
    private tokensService: TokensService,
    private storageService: StorageService,
    private _changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    public media: TdMediaService) {
  }

  ngOnInit(): void {
    this.load();
  }

  async switchClient(c: any) {
    console.log(c.name + " " + c.guid);
    let token: any = this.authenticationService.getToken();
    this.tokensService.changeClient(token, c.guid)
            .subscribe(
            data => {
                this.authenticationService.setToken(data);
                this.client = data.clientName;
                this.reloadMainComponent();
            },
            error => {
                this._dialogService.openAlert({ message: error.message, title: 'Warnung' });
            });
  }

  switchStorage(s: any) {
      this.authenticationService.setStorageName(s.name);
      this.storageName = s.name;
      this.reloadMainComponent();
  }
  
  reloadMainComponent() {
        let currentUrl = this.route.snapshot.queryParams['returnUrl'] || '';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.navigate([currentUrl]);
    }

  async load(): Promise<void> {
    try {
      let token: any = this.authenticationService.getToken();
      this.client = token.clientName;
      this.user = token.userName;
      this.storageName = this.authenticationService.getStorageName();
      this.clients = await this.tokensService.getClients(token).toPromise();
      this.storages = await this.storageService.getStorages(token).toPromise();
    } catch (error) {

    } finally {
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/login/clientswitch.component.ts